<template>
  <div>
    <div class="d-inline-flex mb-4">
      <div class="form-check mr-3" v-if="lightsFields && lightsFields.length">
        <input
          class="check form-check-input select-all mt-0"
          type="checkbox"
          v-model="selectAll"
        />
      </div>
      <h4 class="mr-3 mb-0">Lights </h4>
      <div class="d-flex align-items-center">
        <span class="cursor-pointer" @click="addNewLight()">
          <img
            src="~@/assets/addplus_icon.svg"
            width="20"
            class="heading-icon"
          />
        </span>
        <span
          v-if="isSelected"
          class="cursor-pointer ml-3"
          @click="deleteAllLights()"
        >
          <i class="fa fa-trash"></i>
        </span>
      </div>
    </div>
    <div class="mb-5" v-for="(item, index) in lightsFields" :key="index">
      <div class="fields-wrapper is-divider is-multi-node mb-3">
        <div class="form-check select-single">
          <input
            class="form-check-input"
            type="checkbox"
            @change="checkSingleSelect"
            v-model="item.light.selectSingle"
          />
        </div>
        <div
          class="action-buttons"
        >
          <span
            class="action-item "
            @click="copyLight(index, item)"
          >
            <i class="fa fa-copy"></i>
          </span>
          <span
            v-if="item.light.selectSingle"
            class="action-item"
            @click="deleteLight(index)"
          >
            <i class="fa fa-trash"></i>
          </span>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Select light
              </label>
              <div class="col-sm-8">
                <select class="custom-select" v-model="item.light.lightType" @change="lightTypeChanged(index)">
                  <option value="point">Point Light</option>
                  <option value="spot">Spot Light</option>
                </select>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label for="start_time" class="col-sm-4 col-form-label">
                Start Time
              </label>
              <div class="col-sm-8">
                <input type="mumber" class="form-control" id="start_time" v-model="item.light.startTime" @change="setDuration(index)">
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label for="start_time" class="col-sm-4 col-form-label">
                End Time
              </label>
              <div class="col-sm-8">
                <input type="number" class="form-control" id="end_time" v-model="item.light.endTime" @change="setDuration(index)">
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Duration
              </label>
              <div class="col-sm-8">
                <input 
                  type="number" 
                  :value="(item.light.endTime - item.light.startTime).toFixed(2)" 
                  class="form-control" 
                  id="light_duration_e"
                  readonly
                >
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label" for="range">
                Range
              </label>
              <div class="col-sm-8">
                <input type="number" class="form-control" id="range" v-model="item.light.range">
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label" for="exposure">
                Exposure
              </label>
              <div class="col-sm-8">
                <input type="range"  min="0" max="2" v-model="item.light.exposure" />
                <span class="ml-3">{{ item.light.exposure }}</span>
              </div>
            </div>
            <div class="row form-group align-items-center" v-if="item.light.lightType == 'spot'">
              <label class="col-sm-4 col-form-label" for="spotAngle">
                Spot Angle
              </label>
              <div class="col-sm-8">
                <div class="d-flex align-items-center">
                  <span class="p-2">Inner</span>
                  <input type="number" min='0' max='360' class="form-control" id="innerangle" v-model="item.light.innerSpotAngle">
                  <span class="p-2">Outer</span>
                  <input type="number" min='0' max='360' class="form-control" id="outerangle" v-model="item.light.outerSpotAngle">
                </div>  
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label" id="color">
                Color
              </label>
              <div class="col-sm-8">
                <input type="color" id="favcolor" name="favcolor" v-model="item.light.color">

                {{ item.light.color }}

              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Shadow Type
              </label>
              <div class="col-sm-8">
                <select class="custom-select" v-model="item.light.shadowType">
                  <option value="Soft">Soft</option>
                  <option value="Hard">Hard</option>
                  <option value="None">None</option>
                </select>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Shadow Strength
              </label>
              <div class="col-sm-8">
                <input type="range"  min="0" max="1" step="0.1" v-model="item.light.shadowStrength" />
                <span class="ml-3">{{ item.light.shadowStrength }}</span>
              </div>
            </div>
            
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label" for="mode">
                Mode
              </label>
              <div class="col-sm-8">
                <select class="custom-select" v-model="item.light.lightMode">
                  <option value="Realtime">Realtime</option>
                </select>
              </div>
            </div>
             <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Position of the origin
              </label>
              <div class="col-sm-8">
                <div class="d-flex align-items-center">
                  <span class="p-2">x</span>
                  <input type="number" class="form-control border-danger" id="position_of_the_origin_x" v-model="item.light.localPosition[0]">
                  <span class="p-2">y</span>
                  <input type="number" class="form-control border-success" id="position_of_the_origin_y" v-model="item.light.localPosition[1]">
                  <span class="p-2">z</span>
                  <input type="number" class="form-control border-secondary" id="position_of_the_origin_z" v-model="item.light.localPosition[2]">

                </div>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Rotation of the origin
              </label>
              <div class="col-sm-8">
                <div class="d-flex align-items-center">
                  <span class="p-2">x</span>
                  <input type="number" class="form-control border-danger" id="rotation_of_the_origin_x" v-model="item.light.localRotation[0]">
                  <span class="p-2">y</span>
                  <input type="number" class="form-control border-success" id="rotation_of_the_origin_y" v-model="item.light.localRotation[1]">
                  <span class="p-2">z</span>
                  <input type="number" class="form-control border-secondary" id="rotation_of_the_origin_z" v-model="item.light.localRotation[2]">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {uuid} from 'vue-uuid'
import { mapState } from 'vuex'

export default {
  components: {},
  data () {
    return {
      lightsFields: [],
      selectAll: false,
      isSelected: false,
      activeModel: {},
      objectId: '',
      inputData: {
        elementType: 'Light',
        name: '',
        typeOfLight: 'directional_light',
        range: '',
        positionOfOrigin: {
          x: 0,
          y: 0,
          z: 0
        },
        rotationOfOrigin: {
          x: 0,
          y: 0,
          z: 0
        },
        intensity: 0,
        exposure: '',
        spotAngle: '',
        lightcolor: '#ffffff',
        shadowType: 0,
        shadowStrength: 0,
        indirectMultiplier: '',
        mode: '',
        shadowcolor: '#ffffff',
        targetName: '',
        target: '',
        objectAttached: '',
        timeDuration: {
          s: 0,
          e: 0
        }
      }
    }
  },
  created () {
  },

  methods: {
    lightTypeChanged(index) {
      if(this.lightsFields[index].light.lightType != 'spot') {
        delete this.lightsFields[index].light.innerSpotAngle;
        delete this.lightsFields[index].light.outerSpotAngle;
      } else {
        this.lightsFields[index].light.innerSpotAngle = 0
        this.lightsFields[index].light.outerSpotAngle = 0
      }
    },
    copyLight (index, item) {
      let duration = this.nextElement(this.timeLineCursor.toFixed(2));
      let start = 0
      let end = 0
      if (duration >= item.light.duration && this.timeLineCursor >= this.activeModel.startTime) {
        start = this.timeLineCursor.toFixed(2)
        end = (parseFloat(this.timeLineCursor) + parseFloat(item.light.duration)).toFixed(2)
        duration = parseFloat(item.light.duration).toFixed(2)
      } else {
        end = this.lastElementEndTime ? (this.lastElementEndTime + parseFloat(item.light.duration)).toFixed(2) : parseFloat(this.activeModel.startTime) + parseFloat(item.light.duration)
        start = this.lastElementEndTime ? this.lastElementEndTime.toFixed(2) : parseFloat(this.activeModel.startTime)
        duration = parseFloat(item.light.duration).toFixed(2)
      }
      const lastIndex = this.lightsFields.length ? this.lightsFields.length - 1 : 0
      this.lightsFields[index].light.isCopied = !this.lightsFields[index].light.isCopied
      let id =  uuid.v1()
      this.lightsFields.push({
        elementType: 'Light',
        id: id,
        light: {
          name: "Light " + id,
            objectId: id,
            lightType: item.light.lightType,
            range: item.light.range,
            startTime: start,
            endTime: end,
            duration: duration,
            indirectMultiplier: 0,
            lightMode: item.light.lightMode,
            lightMaps: '',
            shadowType: item.light.shadowType,
            shadowStrength: item.light.shadowStrength,
            color: item.light.color,
            exposure: item.light.exposure,
            localPosition: item.light.localPosition,
            localRotation: item.light.localRotation
          }
      })
      this.reflext()
    },
    addNewLight () {
      let duration = this.nextElement(this.timeLineCursor.toFixed(2));
      duration = duration <= 5 ? duration : 5;
      let start = 0
      let end = 0
      if (duration >= 2 && this.timeLineCursor >= this.activeModel.startTime) {
        start = this.timeLineCursor.toFixed(2)
        end = (parseFloat(this.timeLineCursor) + parseFloat(duration)).toFixed(2)
        duration = parseFloat(duration).toFixed(2)
      } else {
        end = this.lastElementEndTime ? (this.lastElementEndTime + 5).toFixed(2) : parseFloat(this.activeModel.startTime) + 5
        start = this.lastElementEndTime ? this.lastElementEndTime.toFixed(2) : parseFloat(this.activeModel.startTime)
        duration = 5
      }
      let id = uuid.v1()
      this.lightsFields.push({
        elementType: 'Light',
        id: id,
        light: {
          name: "Light " + id,
          objectId: id,
          lightType: 'point',
          range: 1,
          startTime: start,
          endTime: end,
          indirectMultiplier: 0,
          lightMode: 'Realtime',
          lightMaps: '',
          shadowType: 'None',
          shadowStrength: 1,
          color: "#ffffff",
          exposure: 1,
          duration: duration,
          localPosition: [
              0,
              0,
              0
            ],
          localRotation: [
              0,
              0,
              0
            ]
        }
      })
      this.reflext()
    },
    nextElement (time) {
      let duration = 5
      let min = 99999999
      let element = this.lightsFields.filter((el) => {
        return (parseFloat(el.light.startTime) <= time && parseFloat(el.light.endTime) > time)
      })
      if (element.length) {
        return 0;
      }
      element = this.lightsFields.forEach((el) => {
        if (parseFloat(el.light.startTime) >= time && parseFloat(el.light.startTime) <= min) {
          duration = parseFloat(el.light.startTime) - time
          min = parseFloat(el.light.startTime)
        }
      })
      return duration;
    },
    reflext () {
      let newChar =
        this.characters &&
        this.characters.map(char =>
          char.objectId === this.objectId
            ? {
              ...char,
              object3DElements: 
              char.object3DElements ? [
                ...char.object3DElements.filter(
                  el => !el.hasOwnProperty('light')
                ),
                ...this.lightsFields
              ] :  
              [ ...this.lightsFields ]
            }
            : {...char}
        )
      this.$store.dispatch('updateCharacters', newChar)
    },
    setDuration (index) {
      this.lightsFields[index].light.duration = this.lightsFields[index].light.endTime - this.lightsFields[index].light.startTime
    },
    checkSingleSelect () {
      this.lightsFields.forEach(value => {
        if (value.light.selectSingle) {
          this.isSelected = true
        }
      })
    },
    changeSelectedObject () {
      this.lightsFields  = []
      this.characters.map((val, index) => {
        if (val.active) {
          this.objectId =  val.objectId
          this.activeModel = val
          if (val.object3DElements) {
            val.object3DElements.forEach(element => {
              if (element.elementType === 'Light') {
                this.lightsFields.push(element)
              }
            });
          }
        }
      })
    },
    deleteLight (index) {
      let id = this.lightsFields[index].light.objectId
      if (index > -1) {
        this.lightsFields.splice(index, 1)
      }
      this.reflext()
      this.$root.$emit('removeSubnode', id, 'Light', this.activeModel.objectId)
    },
    deleteAllLights () {
      this.lightsFields = []
      let newChar =
        this.characters &&
        this.characters.map(char => {
            if (char.objectId === this.objectId) {
              let object3DElements = char.object3DElements.filter(value => {
                return !value.light
              })
              return { ...char, object3DElements: object3DElements }
            } else {
              return { ...char }
            }
        })
      this.$store.dispatch('updateCharacters', newChar)
      this.selectAll = false
    },
  },
  mounted () {
    this.lightsFields  = []
      this.characters.map((val, index) => {
        if (val.active) {
          this.objectId =  val.objectId
          this.activeModel = val
          if (val.object3DElements) {
            val.object3DElements.forEach(element => {
              if (element.elementType === 'Light') {
                this.lightsFields.push(element)
              }
            });
          }
        }
      })
  },
  watch: {
    selectAll: function (val) {
      this.isSelected = !!val
      if (this.lightsFields) {
        this.lightsFields.forEach(value => {
          value.light.selectSingle = val
        })
      }
    },
    characters (val) {
      this.changeSelectedObject();
    },
  },
  computed: {
    lastElementEndTime () {
      let max = 0
      this.lightsFields.forEach((el) => {
        if (parseFloat(el.light.endTime) >= max) {
          max = parseFloat(el.light.endTime)
        }
      })
      return max;
    },
    ...mapState([
      'characters',
      'timeLineCursor'
    ]),
  }
}
</script>


// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-components/models/light.vue